{
  "infoj": [
    {
      "title": "qID",
      "field": "id",
      "inline": true
    },
    {
      "type": "key"
    },
    {
      "type": "pin",
      "label": "ST_PointOnSurface",
      "field": "pin",
      "fieldfx": "ARRAY[ST_X(ST_PointOnSurface(geom_3857)),ST_Y(ST_PointOnSurface(geom_3857))]"
    },
    {
      "type": "pin",
      "label": "ST_PointOnSurface",
      "field": "pin2",
      "fieldfx": "ARRAY[ST_X(ST_PointOnSurface(geom_3857)),ST_Y(ST_PointOnSurface(geom_3857))]"
    }
  ]
}
